import { I18n } from 'react-redux-i18n';

import { getTestAttributes } from '@common/utils/tests';
import { Flex } from '@common/components/Flex';
import { Ellipsis } from '@common/components/Ellipsis';
import { FileUpload } from '@common/components/FileUpload';

import { MODULE_NAME } from '../../pedigree-import';

import './file-input.styles.scss';

export const ImportFileInput = (props) => {
  const { onUpload, canUploadFile } = props;
  const [name, setName] = React.useState('');

  const handleImport = React.useCallback(({ file }) => {
    if (canUploadFile()) {
      onUpload(file);
      setName(file.name);
    }
  }, [onUpload, canUploadFile]);

  return (
    <Flex width="100%" className="PedigreeImportFileInput">
      <Ellipsis text={name} className="PedigreeImportFileInput__filename" {...getTestAttributes(MODULE_NAME, 'file-import-name', 'box')} />
      <FileUpload
        config={{
          accept: ['.csv', '.txt'],
          multiple: false,
        }}
        classes={{
          root: 'PedigreeImportFileInput__file-upload',
          placeholder: 'PedigreeImportFileInput__file-upload__placeholder',
          placeholderText: 'PedigreeImportFileInput__file-upload__placeholder__text',
        }}
        placeholderProps={getTestAttributes(MODULE_NAME, 'file-import', 'input')}
        placeholder={I18n.t('Browse')}
        onUpload={handleImport}
      />
    </Flex>
  );
};